module.exports = __webpack_public_path__ + "static/media/facebook-icon.636d9ccd.svg";